import type { RecordStore } from './stores/RecordStore';
import { MockBackend } from './MockBackend';
import { AwsBackend } from './AwsBackendClient';
import type { BackendClient, PlatformBackend } from './types';

export interface CreateBackendDeps {
  store: RecordStore;
  getUser: () => { userId: string } | null;
  idGen: () => string;
  now: () => string;
  mode?: 'mock' | 'aws';
  aws?: { baseUrl: string; getToken: () => string | null };
}

export interface Backend {
  getClient(appId: string): BackendClient;
  platform: PlatformBackend;
}

export function createBackend(deps: CreateBackendDeps): Backend {
  if (deps.mode === 'aws' && deps.aws) {
    const aws = new AwsBackend(deps.aws);
    return { getClient: (appId) => aws.getClient(appId), platform: aws.platform };
  }
  const mock = new MockBackend(deps);
  return { getClient: (appId) => mock.getClient(appId), platform: mock.platform };
}
